import { Close } from '@mui/icons-material';
import PropTypes from 'prop-types';

import { Link } from 'gatsby';
import React, { useState } from 'react';
import styled from 'styled-components';

import Authenticate_RGB from '../images/logos/authenticate_rgb.svg';
import { productsSubMenuItems, resourcesSubMenuItems } from '../helper/constant.js';
import ResponsiveSubMenu from './ResponsiveSubMenu.jsx';

const StyledContainer = styled.div`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    background-color: #fff;
    height: auto;
    z-index: 99999;
    @media screen and (min-width: 912px) {
        display: none;
    }
`;
const StyledHeader = styled.header`
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    box-shadow: 0px 2px 10px 0px #00000026;
`;

const StyledLogoLink = styled(Link)`
    text-decoration: none;
`;

const StyledLogo = styled.img`
    height: auto;
    width: 144px;
`;

const StyledMenu = styled.div`
    height: auto;
    padding: 24px 0px;
    box-shadow: 0px 2px 10px 0px #00000026;
`;

const StyledLink = styled(Link)`
    font-size: 14px;
    font-weight: 400;
    line-height: 16.59px;
    text-decoration: none;
    text-align: center;
    color: #262626;
    padding: 24px 5px 24px 24px;
`;

const StyledCloseIcon = styled(Close)`
    font-size: 24px;
`;

const StyledCtaBtn = styled(Link)`
    display: flex;
    width: fit-content;
    background-color: #0c1a68;
    color: #fff;
    font-family: 'Rubik', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.59px;
    padding: 9.5px 16px;
    border-radius: 4px;
    margin: 24px auto 5px 24px;
    text-decoration: none;
`;

const ResponsiveNavbar = ({ setOpen }) => {
    const [isProductMenuOpen, setIsProductMenuOpen] = useState(false);
    const [isResourcesMenuOpen, setIsResourcesMenuOpen] = useState(false);

    const onCloseMenu = () => {
        setOpen(false);
    };

    const onToggleMenu = (type) => {
        if (type === 'resources') {
            setIsResourcesMenuOpen((wasOpen) => {
                if (!wasOpen) {
                    setIsProductMenuOpen(false);
                }

                return !wasOpen;
            });
        } else {
            setIsProductMenuOpen((wasOpen) => {
                if (!wasOpen) {
                    setIsResourcesMenuOpen(false);
                }

                return !wasOpen;
            });
        }
    };

    return (
        <StyledContainer>
            <StyledHeader>
                <StyledLogoLink to="/">
                    <StyledLogo
                        src={Authenticate_RGB}
                        alt="Authenticating.com"
                        width="auto"
                        height="auto"
                        loading="lazy"
                    />
                </StyledLogoLink>
                <StyledCloseIcon onClick={onCloseMenu} />
            </StyledHeader>
            <StyledMenu>
                <StyledLink to="/#solution">Solutions</StyledLink>
                <ResponsiveSubMenu
                    title="Products"
                    isMenuOpen={isProductMenuOpen}
                    menuItems={productsSubMenuItems}
                    toggleMenu={() => onToggleMenu('products')}
                />
                <StyledLink to="/#pricing">Pricing</StyledLink>
                <ResponsiveSubMenu
                    title="Resources"
                    isMenuOpen={isResourcesMenuOpen}
                    menuItems={resourcesSubMenuItems}
                    toggleMenu={() => onToggleMenu('resources')}
                />
                <StyledLink to="/#contact">Contact Us</StyledLink>
                <StyledCtaBtn
                    href="https://portal.authenticate.com/register"
                    target="_blank"
                    rel="noreferrer"
                >
                    Get Started
                </StyledCtaBtn>
            </StyledMenu>
        </StyledContainer>
    );
};

ResponsiveNavbar.propTypes = {
    setOpen: PropTypes.func,
};

export default ResponsiveNavbar;
